import React, { Component } from 'react';
import { Container, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { getContracts, createContract, removeContract } from "services/contractService";
import { getNetworks } from "services/networkService";
import Header from '../../components/Headers/Header';
import GeneralModal from '../../components/Modals/GeneralModal';
import Select from 'react-select';
import ReactTable from 'react-table';
import "react-table/react-table.css";
import { withAlert } from 'react-alert'
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';


class Index extends Component {

    constructor(props){
        super(props);
        this.state = this.defaultState();
        this.token = window.zoomCrypt.get("token");
        this.networkId = window.zoomCrypt.get("networkId")
    }

    defaultState() {
        return {
            contractData: [],
            networkData: [],
            selectedNetwork1: null,
            selectedNetwork2: null,
            openModal: false,
            selectedOption: null,
        };
    }

    refreshPage() {
        this.setState(this.defaultState(), () => this.getDatas()); 
    }

    handleSelectedNetwork1 = selectedNetwork1 => {
        this.setState({ selectedNetwork1 });
    }

    handleSelectedNetwork2 = selectedNetwork2 => {
        this.setState({ selectedNetwork2 });
    }

    onSaveClick = async e => {
        e && e.preventDefault();
        const alert = this.props.alert;
        if(this.state.selectedNetwork1 !== null && this.state.selectedNetwork2){
            const response = await createContract(this.token, this.state.active, this.state.selectedNetwork1.value, this.state.selectedNetwork2.value);
            if(response.status === 200){
                this.refreshPage();
            }
            else {
                alert.show('An error occured while trying to delete. Please try again')
            }
        }else {            
            alert.show('Please fill in all fields !')
        }
    }

    toggle = () => {
		this.setState({openModal: !this.state.openModal})
    }

    getContracts = async () => {
        const responseContracts = await getContracts(this.token, this.networkId);
        let initialContracts = [];
        if(responseContracts.success){
            responseContracts.contracts.map((contract) => {
                initialContracts.push({
                    id: contract.Id,
                    network1: contract.Network1,
                    network2: contract.Network2
                })
            })
        }

        this.setState({
            contractData: initialContracts
        })
    }

    getNetworks = async () => {
        const response = await getNetworks(this.token);
        let initialNetworks = [];
        if(response.success){
            response.networks.forEach((network) => {
                initialNetworks.push({
                    value: network.Id,
                    label: network.Name,
                })
            })

            this.setState({
                networkData: initialNetworks
            })
        }
    }

    handleChangeActive = e => {
        let active = e.target.checked;
        this.setState({ active });
    }

    confirm = (contractId) => {
        confirmAlert({
            title: 'Remove Contract',
            message: 'Are you sure you want to delete ?',
            buttons: [
            {
                label: 'Yes',
                onClick: () => this.remove(contractId)
            },
            {
                label: 'No',
            }
            ]
        });
    };


    remove = async (contractId) =>{
        const alert = this.props.alert;
        const response = await removeContract(this.token, this.networkId, contractId);
        if(response.status === 204)        
            this.refreshPage();
        else            
            alert.show('An error occured while trying to delete. Please try again');

    }

    goEdit = (cId) => {
        this.props.history.push(`contract/edit/${cId}`)
    }

    filterCaseInsensitive(filter, row) {
        const id = filter.pivotId || filter.id;
        return (
            row[id] !== undefined ?
                String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
            :
                true
        );
    }

    getDatas() {
        this.getContracts();
        this.getNetworks();    
    } 

    componentDidMount() {
        this.getDatas();
    }
        

    render() {
        const columns = [
            {
                Header: "Source Network",
                accessor: "network1"
            },
            {
                Header: "Target Network",
                accessor: "network2"
            },
            {
                Header: "Remove",
                Cell: props => {
                    return(
                        <Button onClick={() => this.confirm(props.original.id)} color="danger">Remove</Button>
                    )
                },
                accessor: "remove",
                filterable: false,
                sortable: false
            }
        ]

        return (
            <div>
                <Header></Header>
                <Container className="mt-10">
                    <ReactTable
                        className="zoom-table"
                        columns={columns}
                        filterable
                        defaultFilterMethod={this.filterCaseInsensitive}
                        showPaginationTop={true}
                        data={this.state.contractData}>
                    </ReactTable>
                    <GeneralModal
                        isOpen={this.state.openModal}
                        toggle={this.toggle}
                        title='Create Contract'
                        primaryButton='Create'
                        className='modal-content bg-light'
                        secondaryButton='Cancel'
                        onAction={this.onSaveClick}>
                        <Form>
                        <FormGroup>
                                <Label for="cultureSelect">Source Network</Label>
                                <Select
                                    value={this.state.selectedNetwork1}
                                    options={this.state.networkData}
                                    onChange={this.handleSelectedNetwork1}
                                ></Select>
                            </FormGroup>
                            <FormGroup>
                                <Label for="cultureSelect">Target Network</Label>
                                <Select
                                    value={this.state.selectedNetwork2}
                                    options={this.state.networkData}
                                    onChange={this.handleSelectedNetwork2}
                                ></Select>
                            </FormGroup>
                            <FormGroup check className="mb-3">
                                <Label check>
                                <Input type="checkbox" checked={this.state.active || false} onChange={this.handleChangeActive}/>{' '}
                                    Active
                                </Label>
                            </FormGroup>
                        </Form>
                    </GeneralModal>
                    <Button className="create-button" color="success" onClick={this.toggle}>
                        Create Contract
                    </Button>
                </Container>
            </div>
        )
    }
}

export default withAlert()(Index)